import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import useViewportVisibility from 'hooks/use-viewport-visibility';
import usePaths from 'src/hooks/use-paths';
import { GenericCarousel } from './generic-carousel';

export function SpecialsCarousel(props) {
  const { showOffersCarousel, section } = props;
  const { ref, hasBeenVisible } = useViewportVisibility();
  const { loading, products } = useDispensaryProducts({
    filters: { isOnSpecial: true, useCache: true },
    perPage: 15,
    useBatch: true,
  });
  const { href, route } = usePaths({ specials: true });
  const label = showOffersCarousel ? `Items on Sale` : `Specials`;

  if (!products?.length && !loading && hasBeenVisible) {
    return null;
  }

  const sectionProps = {
    ...props,
    hasBeenVisible,
    isLoading: loading,
    linkLabel: section.linkLabel,
    label,
    products,
    href,
    route,
  };

  return <GenericCarousel ref={ref} {...sectionProps} />;
}
